import { Component, computed, inject, signal } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { StationType } from '@app/shared/enums/station-type.enum';
import { StationFacade } from '@app/station/station.facade';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { MatButton, MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { FormsModule } from '@angular/forms';
import { toSignal } from '@angular/core/rxjs-interop';

@Component({
    selector: 'app-lexicon',
    templateUrl: './lexicon.component.html',
    styleUrls: ['./lexicon.component.scss'],
    imports: [MatButton, MatIconButton, MatIcon, TranslateModule, FormsModule]
})
export class LexiconComponent {
  private readonly router = inject(Router);
  private readonly route = inject(ActivatedRoute);
  private readonly facade = inject(StationFacade);
  private readonly lexiconStations$ = this.facade.getStationsByType(StationType.LEXICON_ENTRY);
  private readonly lexiconStationsSignal = toSignal(this.lexiconStations$);
  private readonly sortInverted = signal(false);

  protected readonly translate = inject(TranslateService);
  protected readonly filterText = signal<string>('');
  protected readonly filteredLexiconStationsSignal = computed(() => {
    return this.lexiconStationsSignal().filter(station =>
      station.title[this.translate.getCurrentLang()].toLocaleLowerCase().includes(this.filterText().toLowerCase())
      || station.textlong[this.translate.getCurrentLang()].toLocaleLowerCase().includes(this.filterText().toLowerCase())
    ).sort((a,b) => {
      if (this.sortInverted()) {
        return b.title[this.translate.getCurrentLang()].localeCompare(a.title[this.translate.getCurrentLang()])
      } else {
        return a.title[this.translate.getCurrentLang()].localeCompare(b.title[this.translate.getCurrentLang()])
      }
    }
    );
  });

  protected navigateToEntry(id: string) {
    this.router.navigate([ id ], {relativeTo: this.route});
  }

  protected onInvertSort() {
    this.sortInverted.update(val => !val);
  }

}
